import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Modal, Form, Spinner, Button,
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import config from '../../../../config';
import { Loader } from '../../../Superadmin/TambahAdmin/styles';

const ModalPoster = ({
  id, show, onHide, history,
}) => {
  const formData = new FormData();
  const [poster, setPoster] = useState([]);
  const [statusKonfirm, setStatusKonfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => () => {
    setPoster();
    setLoading(false);
    setStatusKonfirm(false);
  }, [show]);

  const handleSubmit2 = () => {
    setLoading(true);
    formData.append('poster', poster.image, poster.image.name);
    formData.append('status', 'sukses');
    axios.put(`${config.API_BASE_URL}api/pengajuan_kuliah_umum/detail/${id}/`, formData, {
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }).then(
      () => {
        history.push('/Mahasiswa/PengajuanKuliahUmum/DaftarProgres');
      },
    );
    setLoading(false);
  };

  const SUPPORTED_FORMATS = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];

  const FILESIZE = 10485760;

  const handleSubmit1 = (e) => {
    e.preventDefault();
    let errorText = error;
    if (poster) {
      const value = poster.image;
      if (!SUPPORTED_FORMATS.includes(value.type)) {
        errorText = 'Poster harus berupa gambar!';
      } else if (value.size > FILESIZE) {
        errorText = 'Maksimum ukuran poster 10 MB!';
      } else {
        errorText = '';
      }
    } else {
      errorText = 'Poster tidak boleh kosong!';
    }

    if (errorText === '') {
      setStatusKonfirm(!statusKonfirm);
    } else {
      setError(errorText);
    }
  };

  const handleImageChange = (e) => {
    setPoster({
      image: e.target.files[0],
    });
  };

  if (loading) {
    return (
      <Loader>
        <Spinner animation="border" />
      </Loader>
    );
  }

  return (
    <Modal
      show={show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={onHide}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {' '}
        </Modal.Title>
      </Modal.Header>
      {
        !statusKonfirm
          ? (
            <>
              <Modal.Body>
                <h4 className="font-20 mb-4"><u>Unggah Poster</u></h4>
                <Form onSubmit={handleSubmit1} className="form-poster mb-4">
                  <Form.Group controlId="formInputPoster">
                    <Form.Control
                      rows={3}
                      type="file"
                      className="font-24 mb-4"
                      accept="image/png, image/jpeg"
                      onChange={(e) => handleImageChange(e)}
                      data-testid="poster-form"
                      name="poster"
                    />
                    {error !== '' && (
                      <div data-testid="poster_error" className="text-danger">{error}</div>
                    )}
                  </Form.Group>
                  <div className="text-center w-100">
                    <Button
                      className="mr-2"
                      variant="danger"
                      onClick={onHide}
                      data-testid="close"
                    >
                      Batal
                    </Button>
                    <Button
                      type="submit"
                      className="font-20 ml-2"
                      data-testid="selanjutnya"
                    >
                      Selanjutnya
                    </Button>
                  </div>
                </Form>
              </Modal.Body>
            </>
          )
          : (
            <>
              <Modal.Body>
                <h4>Form Konfirmasi</h4>
                <p>
                  Apakah Anda ingin mengirim poster ini sekarang?
                </p>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="btnCancel font-20 mr-2"
                  variant="danger"
                  onClick={() => setStatusKonfirm(!statusKonfirm)}
                  data-testid="kembali"
                >
                  Kembali
                </Button>
                <Button
                  variant="success"
                  onClick={handleSubmit2}
                  data-testid="konfirmasi"
                >
                  Konfirmasi
                </Button>
              </Modal.Footer>
            </>
          )
        }
    </Modal>
  );
};

ModalPoster.defaultProps = {
  show: false,
  onHide: () => 'Do Nothing',
  id: '0',
};

ModalPoster.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  id: PropTypes.string,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default ModalPoster;
